import { Color3 } from "@babylonjs/core/Maths/math.color";

/** Fighter colours, indexed by `PlayerState.color`; chosen to stay distinct when pixelated. */
export const PLAYER_COLORS = [
  "#e8505b",
  "#4fa3f7",
  "#58c87a",
  "#f4b740",
  "#b07cf2",
  "#f08ac0",
  "#4fd1c5",
  "#f28c38",
] as const;

/**
 * Team colours (Phase 4): in a team match every fighter's body, ring and name
 * tag take the team colour, so allies and enemies read apart even at 180
 * lines. Indexed by `Team`.
 */
export const TEAM_COLORS: Readonly<Record<number, string>> = {
  1: "#3d8bff",
  2: "#ff5a4d",
};

export const TEAM_NAMES: Readonly<Record<number, string>> = {
  1: "Blu",
  2: "Rossi",
};

/** CSS colour of a fighter: its team's in a team match, its own otherwise. */
export function fighterCss(colorIndex: number, team: number): string {
  return TEAM_COLORS[team] ?? PLAYER_COLORS[colorIndex % PLAYER_COLORS.length] ?? PLAYER_COLORS[0];
}

export const ARENA_COLORS = {
  sky: "#1c1f33",
  floorA: "#9aa3b5",
  floorB: "#8a93a8",
  floorSide: "#4d5470",
  edge: "#f2c14e",
  pillar: "#6c7593",
  platform: "#b9a888",
  wall: "#5b6280",
  shadow: "#0d0f1a",
} as const;

/** Combat feedback; kept apart from the player colours so effects never read as a team. */
export const COMBAT_COLORS = {
  hitbox: "#fff4e0",
  spark: "#fff4c2",
  heavy: "#f28c38",
  slam: "#f2c14e",
  shield: "#7fe3ff",
} as const;

export function hex(color: string): Color3 {
  return Color3.FromHexString(color);
}
